import { PaginationBtns } from './ui/PaginationBtns'
import './ui/PaginationBtns.scss'
export default PaginationBtns
